import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, retry } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface ISalesforceObjectSummary {
  name: string;
  apiName?: string;
  objectName?: string;
  label?: string;
  custom?: boolean;
}

interface INamespaceMetaLabelsResponse {
  namespace?: string;
  objectNames?: { objectName: string; label?: string }[];
}

export interface ISalesforceObjectMetaField {
  path: string;
  label?: string;
  type?: string;
  associatedEntity?: string;
  relationshipName?: string;
}

export interface ISalesforceObjectMetaResponse {
  objectName?: string;
  fields?: ISalesforceObjectMetaField[];
}

@Injectable({ providedIn: 'root' })
export class SalesforceMetadataService {
  constructor(private http: HttpClient) {}

  // @TODO: cache this
  getObjects(): Observable<ISalesforceObjectSummary[]> {
    const gatewayUrl = `${environment.kpHost}/salesforce/meta/objects?all=true&resolveIcons=false`;
    const labelsUrl = `${environment.kpHost}/datasource/salesforce/meta?labels=true`;
    return this.http.get<ISalesforceObjectSummary[]>(gatewayUrl).pipe(
      switchMap((objects) => {
        if ((objects ?? []).length > 0) {
          return of(objects ?? []);
        }
        // @TODO: figure fallback if any
        return this.http.get<INamespaceMetaLabelsResponse>(labelsUrl).pipe(
          retry(3),
          map((response) =>
            (response?.objectNames ?? []).map((entry) => ({
              name: entry.objectName,
              apiName: entry.objectName,
              objectName: entry.objectName,
              label: entry.label,
            })),
          ),
          catchError(() => of([])),
        );
      })
    );
  }

  getObjectMeta(objectName: string): Observable<ISalesforceObjectMetaResponse> {
    const safeObjectName = encodeURIComponent(objectName ?? '');
    const url = `${environment.kpHost}/datasource/salesforce/meta/${safeObjectName}?fields=*`;
    return this.http.get<ISalesforceObjectMetaResponse>(url);
  }
}
